import React from 'react';
import { Flex } from '@withjoy/joykit';
import { useIsMobileOrTablet } from '@shared/utils/media/useMediaScreens';
import { AccommodationsConsoleHeader } from './components/Header';
import { FiltersPanel } from './components/FiltersPanel/FiltersPanel';
import { ListingsPanel } from './components/ListingsPanel/ListingsPanel';
import { AccommodationMapListSync } from './components/AccommodationMapListSync/AccommodationMapListSync';

// Full-footprint console skeleton (header + filters + listings), matching the placeholder the
// console renders while loading. Used by GuestHotelSearch to hold the cash-fund gating decision
// without mounting (and fetching for) a console, avoiding a double-mount/flash on the swap.
//
// NOTE: ListingsPanel.Skeleton → ListingEntry.Skeleton renders a `Container` that consumes the
// AccommodationMapListSync context, so this skeleton must provide it (it is rendered standalone,
// outside the console tree).
export const AccommodationsConsoleLayoutSkeleton = ({ showJoyTravelBenefitsFilter = false }: Readonly<{ showJoyTravelBenefitsFilter?: boolean }>) => {
  const isMobileOrTablet = useIsMobileOrTablet();
  return (
    <AccommodationMapListSync>
      <Flex
        flexDirection="column"
        width="100%"
        height="100dvh"
        maxWidth="100%"
        overflow="auto"
      >
        <AccommodationsConsoleHeader.Skeleton />
        <Flex
          overflow="auto"
          flex={1}
          minHeight={isMobileOrTablet ? '400px' : 0}
        >
          <FiltersPanel.Skeleton showJoyTravelBenefitsFilter={showJoyTravelBenefitsFilter} />
          <ListingsPanel.Skeleton isMobileOrTablet={isMobileOrTablet} />
        </Flex>
      </Flex>
    </AccommodationMapListSync>
  );
};
